import { render, staticRenderFns } from "./ficha-producto.vue?vue&type=template&id=0d9ace36"
import script from "./ficha-producto.vue?vue&type=script&lang=js"
export * from "./ficha-producto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports